// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue'
import App from './App'
import router from './router'
import ViewUI from 'view-design'
import store from './vuex'
import 'view-design/dist/styles/iview.css'
import global from '@/api/global.js'
import animated from 'animate.css' 
import moment from "moment"; // 1.引入
Vue.prototype.$moment = moment // 2.挂载到原型
moment.locale("zh-cn") // 3.汉化

Vue.use(animated)
Vue.use(ViewUI)
Vue.config.productionTip = false
Vue.prototype.GLOBAL = global
/* eslint-disable no-new */
new Vue({
  el: '#app',
  router,
  store,
  components: { App },
  template: '<App/>'
})



// WEBPACK FOOTER //
// ./src/main.js